import { Role } from "webportalclient";
import { Query, Report, Permission, QueryOrderDirection, SSRSCredential, QueryCondition } from "../misc/api/apiTypes";
import { Folder } from "../misc/api/ReportsApiTypes";
import { ReportFormat } from "./ReportActions";

export interface ReportOpeningState {
    id: string;
    isRequestingDownload: boolean;
    format: ReportFormat;
}

export enum ReportAdministrationView {
    Hidden = 'Hidden',
    Loading = 'Loading',
    Credentials = 'Credentials',
    RootFolder = 'RootFolder',
}

export interface ReportsListTableState {
    reportsQuery: Query<Report>;
    nameFilterQuery: Query<any>;
    errorMessage: string;
    reportOpening: ReportOpeningState;
    hideWidgets: boolean;
    showReportModal: boolean;
    selectedReportId?: string;
}

export const initialListTableState: ReportsListTableState = {
    reportsQuery: {
        Order: {
            Member: 'Name',
            Direction: QueryOrderDirection.Ascending,
        },
        Filters: [],
        Page: {
            Length: 10,
            Current: 1,
        }
    },
    nameFilterQuery: {
        Members: ['Name'],
        Order: {
            Member: 'Name',
            Direction: QueryOrderDirection.Ascending,
        },
        Filters: [],
        Page: {
            Length: 0,
            Current: 1,
        }
    },
    errorMessage: null,
    reportOpening: null,
    hideWidgets: false,
    showReportModal: false
}

export interface ReportsAdministrationState {
    isConnectedToReportServer?: boolean,
    isConnectionModalVisible?: boolean,
    currentView: ReportAdministrationView;
    availableFolders: Query<Folder>;
    credentials: SSRSCredential;
    isReportRolesModalVisible: boolean;
    availableRoles: Role[];
    activeReportId: string;
    selectedStudyRootFolder: string;
}

export const initialAdministrationState: ReportsAdministrationState = {
    currentView: ReportAdministrationView.Loading,
    availableFolders: null,
    isConnectedToReportServer: null,
    isConnectionModalVisible: false,
    credentials: null,
    isReportRolesModalVisible: false,
    availableRoles: null,
    activeReportId: null,
    selectedStudyRootFolder: null
}

export interface ReportsState {
    listTable: ReportsListTableState;
    administration: ReportsAdministrationState;
}

export const initialReportsState: ReportsState = {
    listTable: initialListTableState,
    administration: initialAdministrationState,
}


